import { Claim, CreateClaimForm } from 'interfaces';

import { nowISO } from 'utils/dateUtils';

const deepClone = <T>(value: T): T => {
  return value == null ? value : JSON.parse(JSON.stringify(value));
};

export const mapClaimToCreateClaimForm = (
  claim: Claim,
  overrides: Partial<CreateClaimForm> = {},
  userID: string
): CreateClaimForm => {
  const source = deepClone(claim);

  const newClaim = {
    ...source,
    id: undefined,
    claimNumber: undefined,
    updatedAt: undefined,
    payor: undefined,
    group: undefined,
    groupID: undefined,
    createdByUser: undefined,
    debits: undefined,
    submissions: undefined,
    claimHistories: undefined,
    remittances: undefined,
    invoices: undefined,
    actionRequests: undefined,
    actionResponses: undefined,
    credit: undefined,
    provider: undefined,
    providerID: undefined,
    createdAt: nowISO('UTC'),
    siteID: claim.site.id,
    site: claim.site,
    healthcard: claim.healthcard,
    version: 1,
    patientCount: source.patientCount ?? 1,
    overhead: source.overhead ?? claim.site.overhead ?? 0,
    createdBy: userID,
    messageID: null,
    statementID: null,
    intakeItemID: null,
    resubmit: false,
    internalComments: '',
    ...overrides,
  } as CreateClaimForm;

  return newClaim;
};
